import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCreateGuidedChat } from "../hooks/useGuidedChat";

export function NewChatRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const chatType = searchParams.get("type") || "reflection";
  const hasCreated = useRef(false);

  const { mutateAsync } = useCreateGuidedChat();

  useEffect(() => {
    if (hasCreated.current) return;
    hasCreated.current = true;

    mutateAsync({ chat_type: chatType })
      .then((chat) => {
        navigate(`/guided-chat/${chat.id}`, { replace: true });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, [chatType, mutateAsync, navigate]);

  return (
    <div className="min-h-screen-safe flex items-center justify-center bg-white">
      <div className="text-text-secondary">Starting your reflection...</div>
    </div>
  );
}
